export default {"src":"/_next/static/media/generic-residential-icon.ee63c393.svg","height":85,"width":105,"blurWidth":0,"blurHeight":0};